import React from "react";
import { toastr } from "react-redux-toastr";
import { Customer } from "../../../core/api/models";
import noImage from "../user-noimage.png";
import api from "../../../api";
import { useHasPermission } from "../../../core";
import { AppPermissions } from "../../../core/api/models/permissions";
import CustomerLeads from "./customer-leads/CustomerLeads";

const ExistingClient: React.FunctionComponent<{
  customerDetails?: Customer;
  setStage: (stage: string) => void;
  phone?: string;
  onLeadClick: (id: string) => void;
  civilId?: string;
  isCompanyLead?: boolean;
  addExistingCustomerAsUser?: (data: Customer) => void;
  onClose?: () => void;
}> = (props) => {
  const canUnlinkCustomerPhone = useHasPermission(
    AppPermissions.UnlinkCustomerPhone
  );
  const canCreateCustomer = useHasPermission(AppPermissions.CreateCustomer);

  const [openModal, setOpenModal] = React.useState(false);
  const [isSubmiting, setSubmiting] = React.useState(false);

  const onSendSms = async () => {
    setSubmiting(true);
    try {
      const response = await api.customer.unlinkPhoneSendSms(
        props.phone || "",
        props.customerDetails?._id
      );

      props.setStage("otp");
    } catch (error) {
      toastr.error("Error", error?.response?.data?.message);
    }
    setSubmiting(false);
  };

  const renderUnlink = () => {
    return openModal ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>
                        Are you sure want to unlink phone number {props.phone}{" "}
                        from {props.customerDetails?.fullName}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={() => setOpenModal(false)}
                        disabled={isSubmiting}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={onSendSms}
                        disabled={isSubmiting}
                      >
                        Unlink
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  return (
    <>
      {props.customerDetails && (
        <div className="d-flex border-bottom align-items-center py-2 px-4 ">
          <h6 className="mb-0">It looks this client already exists</h6>
        </div>
      )}
      <div className="p-4 ">
        <p className="font-sm mb-2">
          {props.customerDetails ? (
            <>
              {!props.customerDetails.isCompanyCustomer ? (
                <>
                  {" "}
                  We ‘ve found an existing client with given phone number in
                  your records{" "}
                </>
              ) : (
                <>
                  {" "}
                  We ‘ve found an existing client with given phone number in
                  your records
                </>
              )}
            </>
          ) : (
            <>
              We haven't found an existing client with given phone number in
              your records
            </>
          )}
        </p>
        {props.customerDetails && (
          <div className="border rounded p-3 d-flex mb-4">
            <div className="avatar position-relative mr-3">
              <img
                src={props.customerDetails?.photo?.location || noImage}
                className="img-cover img-fluid rounded-circle"
                alt="user image"
              />
            </div>
            <div>
              <h6 className="font-weight-semibold mb-1">
                {props.customerDetails?.firstName}{" "}
                {props.customerDetails?.lastName}
              </h6>
              {props.customerDetails &&
                props.customerDetails.phones &&
                props.customerDetails.phones.length > 0 && (
                  <p className="font-sm font-weight-semibold mb-1">
                    <a
                      href={`tel:+${props.customerDetails.phones[0].phone}`}
                      className="text-gray-700"
                    >
                      +{props.customerDetails.phones[0].phone}
                    </a>
                  </p>
                )}

              {props.customerDetails &&
                props.customerDetails.emails &&
                props.customerDetails.emails.length > 0 && (
                  <p className="font-sm font-weight-semibold mb-1 text-gray-700">
                    <a
                      href="mailto:harold_adams@gmail.com"
                      className="text-gray-700"
                    >
                      {props.customerDetails.emails[0].email}
                    </a>
                  </p>
                )}
            </div>
          </div>
        )}
        <h6 className="pt-2 mb-3 font-weight-normal font-sm">
          Here's what you can do:
        </h6>
        {props.customerDetails && !props.isCompanyLead ? (
          <>
            <button
              className="btn btn-primary btn-block font-normal font-weight-bold mb-2"
              onClick={() => props.setStage("lead-details")}
            >
              Add a new lead for {props.customerDetails?.firstName}{" "}
              {props.customerDetails?.lastName}
            </button>
            {props.phone && canUnlinkCustomerPhone && (
              <button
                className="btn btn-outline-primary btn-block font-normal font-weight-bold mb-2"
                onClick={() => setOpenModal(true)}
              >
                Unlink Mobile Number from {props.customerDetails?.firstName}{" "}
                {props.customerDetails?.lastName}
              </button>
            )}
          </>
        ) : (
          <>
            {canCreateCustomer && !props.isCompanyLead && (
              <button
                className="btn btn-outline-primary btn-block font-normal font-weight-bold mb-2"
                onClick={() => props.setStage("create-customer")}
              >
                Add a new Customer
              </button>
            )}
          </>
        )}

        {!props.isCompanyLead ? (
          <button
            // onClick={() => props.setStage("fetch-customer")}
            onClick={() => props?.onClose ? props?.onClose() : props?.setStage("lead-details")}
            className="btn btn-outline-dark btn-block font-normal font-weight-bold btn-goback text-gray-500 mb-2"
          >
            Go Back
          </button>
        ) : (
          <>
            <button
              onClick={() => {
                props.addExistingCustomerAsUser?.(props.customerDetails!);
              }}
              className="btn btn-primary btn-block font-normal font-weight-bold"
            >
              Add Contact
            </button>
            <button
              onClick={() =>
                // props.onClose ? props.onClose() : props.setStage("add-user")
                props?.onClose ? props?.onClose() : props?.setStage("lead-details")
              }
              className="btn btn-outline-dark btn-block font-normal font-weight-bold btn-goback text-gray-500 mb-2"
            >
              Go Back
            </button>
          </>
        )}
      </div>
      {!props.isCompanyLead && renderUnlink()}
      {/* CustomerLeads Not need for existing contact */}
      {/* <CustomerLeads
        customerId={props.customerDetails?._id || ""}
        onLeadClick={props.onLeadClick}
      ></CustomerLeads> */}
    </>
  );
};

export default ExistingClient;
